<template>
  <div class="container service-contact">
    <div class="row mb-3">
      <div class="col-md-4 mx-auto">
        <div class="soyuz">
          <div class="view rocket text-center mb-lg-4 pb-2">
            <img
              src="@/assets/brand/logo-nav-black.webp"
              class="img-fluid"
              alt="smaple image"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="service-contact__text">
      <h3 class="text-center mb-4 pb-2">
        Simplifiez vos <strong>livraisons sur chantier</strong> avec
        <span class="brand-name">Livratos</span>
      </h3>

      <p class="text-center mx-auto mb-4 pb-2">
        Une question sur la <strong>livraison</strong>, le fonctionnement de la
        plateforme ou l’intégration pour votre activité de
        <strong>fournisseur BTP</strong> ? Contactez-nous et nous vous guiderons
        pour optimiser vos commandes et accompagner vos
        <strong>artisans</strong> au quotidien.
      </p>

      <a :href="linkBtnFooter" class="btn btn-secondary btn-rounded btn-md">
        <i class="fas fa-clone left"></i>
        <strong> Découvrir Livratos</strong>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "CallActionFooter",
  props: {
    linkBtnFooter: {
      type: String,
      default: "/contact", // Couleur par défaut si la prop n'est pas fournie
    },
  },
};
</script>

<style lang="scss" scoped>
.brand-name {
  color: $color-primary;
}
.service-contact {
  margin-top: 100px;
  margin-bottom: 200px;
  @media screen and (min-width: 992px) {
    margin-top: 200px;
  }
  &__text {
    display: flex;
    flex-direction: column;
    justify-content: center;
    & h3 {
      color: $color-text;
    }
    & p {
      color: $color-darker;
    }
    & a {
      background: $color-darker;
      width: fit-content;
      margin: auto;
      &:hover {
        background: $color-primary;
        border-color: $color-text;
      }
    }
  }
}
</style>
